export enum Tags {
  Reviewed = 'reviewed',
  Nsfw = 'nsfw',
  CopyrightedContent = 'copyrighted-content',
  Illegal = 'illegal',
  Approved = 'approved',
}
